import axiosInstance from "../../api/axios";

const ArtistService = {
  getAllArtists: async () => {
    const response = await axiosInstance.get("/artists");
    return { success: true, data: response.data.artists ?? [] };
  },
};

export default ArtistService;
